import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Observable, map, takeUntil } from 'rxjs';

import { GetEnumValuesDto } from 'src/app/core/api/models';
import {
  EnumsService,
  OutboxMessageNumbersService,
} from 'src/app/core/api/services';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'delivery-status-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class DeliveryStatusSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('scheduledMessageId') input_scheduledMessageId: number;
  DeliveryStatusEnumValues: GetEnumValuesDto[] = [];
  constructor(
    protected currentService: OutboxMessageNumbersService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  ngOnInit(): void {
    this.getEnumValuesApi('DeliveryStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => {
        this.DeliveryStatusEnumValues = values;
        this.initConfig();
        this.getItems();
      });
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'content';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) this.getItemsApi();
  }

  getItemsApi() {
    this.unSubs();
    this.currentService
      .outboxMessageNumbersGetOutboxMessageDeliveryStatusStatisticsByScheduledMessageId(
        { body: { scheduledMessageId: this.input_scheduledMessageId } }
      )
      .pipe(
        this.basePipeOperators(),
        map((items) => {
          return items.data.map((item) => {
            const translatedSmsCpType = this.enumToTextConvertorPipe.transform(
              item.deliveryStatus,
              this.DeliveryStatusEnumValues
            );
            return {
              ...item,
              id: item.deliveryStatus,
              content: `
              <div class="tw-flex tw-justify-between tw-items-center dir-rtl">
              <div
              >
              ${translatedSmsCpType}
              </div>
              <span
                class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
                >
                ${item.count}
                </span
              >
            </div>
              `,
            };
          });
        })
      )
      .subscribe(this.baseObserver);
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }
}
